import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import AuthShell from "../components/AuthShell";
import { useAuth } from "../context/AuthContext";

export default function Logout() {
  const { logout } = useAuth();
  const ran = useRef(false);

  useEffect(() => {
    // Run only once on mount — logout() is async but we intentionally fire-and-forget.
    if (ran.current) return;
    ran.current = true;
    logout();
  }, [logout]);

  return (
    <AuthShell>
      <div className="text-center" data-testid="logout-page">
        <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-[#34C97B]/15 border border-[#34C97B]/40 mb-4">
          <CheckCircle2 size={28} className="text-[#34C97B]" />
        </div>
        <h1 className="text-2xl font-bold text-white">Logged out successfully</h1>
        <p className="text-sm text-white/60 mt-2">See you soon. Your session has been cleared from this device.</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-7">
          <Link
            to="/login"
            className="inline-flex items-center justify-center gap-2 bg-[#34C97B] hover:bg-[#22B36A] text-white font-semibold py-3 px-4 rounded-xl transition"
            data-testid="logout-login-again-btn"
          >
            Login Again
          </Link>
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 border border-white/20 hover:border-[#34C97B]/60 hover:text-[#34C97B] text-white/90 font-semibold py-3 px-4 rounded-xl transition"
            data-testid="logout-home-btn"
          >
            Go to Home
          </Link>
        </div>
      </div>
    </AuthShell>
  );
}
